import script from "./PrimaryChannelDataStatistics.vue?vue&type=script&setup=true&lang=js"
export * from "./PrimaryChannelDataStatistics.vue?vue&type=script&setup=true&lang=js"

import "./PrimaryChannelDataStatistics.vue?vue&type=style&index=0&id=dfaadc14&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dfaadc14"]])

export default __exports__